import React, { FC, memo } from 'react'
import Grid from '@sport1/react-elements/Grid'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import Touchable from '@sport1/react-elements/Touchable'
import Image from '../../BaseComponents/Image'
import { TestID } from '../../utils/PropTypesDefinitions'
import LabelFont from '../../Theme/Fonts/Label'
import SmallBodyFont from '../../Theme/Fonts/SmallBody'

export type CompetitionHeaderProps = {
    /** url to the competition logo */
    imageUrl?: string
    /** info about imageUrl for seo */
    alt?: string
    /** name of the competition, e.g. Bundesliga */
    leagueName: string
    /** name of the sport, e.g. Basketball */
    sportsName?: string
    /**
     * function called when pressed on the favorite icon
     * @TJS-type function
     * */
    onAddFavorite?: () => void
    /**
     * function called when pressed on the header
     * @TJS-type function
     * */
    onPressHeader?: () => void
    /**
     * flag to render the favorite icon at all
     * */
    showFavorite?: boolean
    /**
     * flag to show if the current competition is favored
     * */
    isFavorite?: boolean
} & TestID

const CompetitionHeader: FC<CompetitionHeaderProps> = ({
    sportsName,
    imageUrl,
    leagueName,
    showFavorite,
    isFavorite,
    testID = 'competition_header',
    alt,
    onPressHeader,
    onAddFavorite,
}) => {
    return (
        <Grid horizontal backgroundColor="GRAY25" testID={`${testID}_container`}>
            <Grid horizontal minWidth={0}>
                <Touchable expand onPress={onPressHeader} testID={`${testID}_on_press`}>
                    <Grid centerVertical horizontal>
                        <Grid
                            borderRadius={18}
                            width={36}
                            height={36}
                            marginLeft={5}
                            marginRight={3}
                            marginY={4}
                            noExpand
                            center
                            backgroundColor="pearl-4"
                        >
                            <Image
                                width={24}
                                size="S"
                                radiusType="none"
                                aspectRatio="1:1"
                                imageUrl={imageUrl}
                                testID={testID}
                                alt={alt}
                            />
                        </Grid>
                        <Grid backgroundColor="GRAY25" minWidth={0}>
                            <SmallBodyFont
                                bold
                                color="WHITE"
                                textAlign="left"
                                numberOfLines={1}
                                testID={`${testID}_league_name`}
                            >
                                {leagueName.toUpperCase()}
                            </SmallBodyFont>
                            {sportsName ? (
                                <LabelFont
                                    color="keshi-3"
                                    textAlign="left"
                                    numberOfLines={1}
                                    testID={`${testID}_label`}
                                >
                                    {sportsName}
                                </LabelFont>
                            ) : null}
                        </Grid>
                    </Grid>
                </Touchable>
            </Grid>
            {showFavorite ? (
                <Grid noExpand centerVertical>
                    <Touchable onPress={onAddFavorite} testID={`${testID}_favorite_button`}>
                        <Grid noExpand alignRight margin={5}>
                            <FontelloIcon
                                textAlign="right"
                                name={isFavorite ? 'favorite-active' : 'favorite'}
                                fontSize={18}
                                color={isFavorite ? 'ORANGE' : 'keshi-3'}
                            />
                        </Grid>
                    </Touchable>
                </Grid>
            ) : null}
        </Grid>
    )
}

export default memo(CompetitionHeader)
